import { render, staticRenderFns } from "./Career.vue?vue&type=template&id=177d450e&scoped=true&"
import script from "./Career.vue?vue&type=script&lang=js&"
export * from "./Career.vue?vue&type=script&lang=js&"
import style0 from "./Career.vue?vue&type=style&index=0&id=177d450e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177d450e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VCard,VIcon})
